import React from 'react'
import styled from 'styled-components'
import { PageHeader, PageSubTitle } from '@appearance/styled'

export default ({}) => {
    return (
        <Container>
            <PageHeader>אישור הרישום בוצע בהצלחה</PageHeader>
            <PageSubTitle>
                אימייל נשלח למשתמש החדש להשלמת תהליך ההרשמה
            </PageSubTitle>
        </Container>
    )
}

const Container = styled.div``
